import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginVertical: 14,
  },
  damagedContainer : {
    flexDirection: 'row',
    justifyContent: 'center',
    marginLeft : 12 , 
    alignItems: 'center',
  },
  title: {
    fontFamily: textStyles.regular,
    fontSize: 10,
    color: colorPalette.grey8,
  },
  textWrapper: {
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  value: {
    fontFamily: textStyles.bold,
    fontSize: 20,
    color: colorPalette.grey9,
  },
  percent: {
    fontSize: 14,
  },
});
